import { thunkOn, ThunkOn } from 'easy-peasy'

let idleTimer: NodeJS.Timeout

const isMainRefiTable = window.location.href.includes('mortgages/refinance-rates')

export interface ActivityTimerModel {
  resetTimer: ThunkOn<ActivityTimerModel>
}

const activityTimerModel: ActivityTimerModel = {
  resetTimer: thunkOn(
    (actions, storeActions: any) => storeActions['tracking'].fireBeam,
    (actions, target, { getStoreActions, getStoreState }) => {
      if (isMainRefiTable) {
        return null
      }
      clearTimeout(idleTimer)
      idleTimer = setTimeout(() => {
        return (getStoreActions as any)()['offers'].getOffers((getStoreState as any)()['dimensions'].dimensions)
      }, 1000 * 60 * 25)
    }
  ),
}

export default activityTimerModel

if (isMainRefiTable) {
  function refreshAfterInactivity(ms: number) {
    let time: NodeJS.Timeout

    const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart']
    events.forEach(event => {
      document.addEventListener(event, startTimer, true)
    })

    function startTimer() {
      clearTimeout(time)
      time = setTimeout(window.location.reload.bind(window.location), ms)
    }
    startTimer()
  }

  refreshAfterInactivity(1000 * 60 * 25)
}
